module.exports = __webpack_public_path__ + "static/logo-stamp-fef6e10f215a0fa7c9165e228671ab4d.svg";